import React, {useEffect, useState} from "react"
import {useOutletContext, useLocation, useNavigate} from "react-router-dom"

function Settings() {

    const oc = useOutletContext().oc
    const navigate = useNavigate()
    const locationArray = useLocation().pathname.split('/').filter((char) => char !== '')
    const accountLocation = locationArray[locationArray.length - 2]

    useEffect(() => {
        if (oc.authChecked && accountLocation != '@' + oc.account) navigate('/' + accountLocation + "/profile")
    }, [oc.authChecked, oc.account])

    return (
        <div id="settings">
            <p>nothing to see here yet...</p>
        </div>
    )
}

export default Settings;